module.exports = __webpack_public_path__ + "img/buzzloading.5fde4298.svg";